<template>
    <div class="detial_box" v-if="company">
        <div class="detial_item">
            <div class="title">公司简介</div>

            <div class="text_box" v-if="company.intro">
                <div v-for="(text, index) in company.intro?.split('\n')" :key="index">{{ text }}</div>
            </div>

            <div class="text_box" style="color: #99999a" v-else>无</div>
        </div>
        <div class="detial_item">
            <div class="title">公司相册</div>

            <div class="img_box" v-if="company.image && company.image.length > 0">
                <img :src="item" v-for="item in company.image" :key="item" alt="" />
            </div>

            <div class="text_box" style="color: #99999a" v-else>无</div>
        </div>
        <div class="detial_item">
            <div class="title">企业文化</div>

            <div class="text_box" v-if="company.company_culture">
                <div v-for="(text, index) in company.company_culture?.split('\n')" :key="index">{{ text }}</div>
            </div>

            <div class="text_box" style="color: #99999a" v-else>无</div>
        </div>
        <div class="detial_item">
            <div class="title">发展历程</div>

            <div class="text_box" v-if="company.development_history">
                <div v-for="(text, index) in company.development_history?.split('\n')" :key="index">{{ text }}</div>
            </div>

            <div class="text_box" style="color: #99999a" v-else>无</div>
        </div>
        <div class="detial_item">
            <div class="title">获得荣誉</div>

            <div class="text_box" v-if="company.company_honor">
                <div v-for="(text, index) in company.company_honor?.split('\n')" :key="index">{{ text }}</div>
            </div>

            <div class="text_box" style="color: #99999a" v-else>无</div>
        </div>
        <div class="detial_item">
            <div class="title">人才发展</div>

            <div class="label_box" v-if="company.talent_development && company.talent_development.length > 0">
                <span class="label_item" v-for="(item, index) in company.talent_development" :key="index">{{ item }}</span>
            </div>

            <div class="text_box" style="color: #99999a" v-else>无</div>
        </div>

        <div class="detial_item">
            <div class="title">工商信息</div>

            <div class="business_box">
                <div class="grid-info">
                    <div class="info-item">
                        <div class="info-item_label">公司名称</div>
                        <div class="info-item_data">{{ company.company_name || "-" }}</div>
                    </div>

                    <div class="info-item">
                        <div class="info-item_label">法定代表人</div>
                        <div class="info-item_data">{{ "-" }}</div>
                    </div>

                    <div class="info-item">
                        <div class="info-item_label">成立日期</div>
                        <div class="info-item_data">{{ company.registration_date || "-" }}</div>
                    </div>

                    <div class="info-item">
                        <div class="info-item_label">企业类型</div>
                        <div class="info-item_data">{{ company.company_type || "-" }}</div>
                    </div>

                    <div class="info-item">
                        <div class="info-item_label">经营状态</div>
                        <div class="info-item_data">{{ company.business_status || "-" }}</div>
                    </div>

                    <div class="info-item">
                        <div class="info-item_label">注册资金</div>
                        <div class="info-item_data">{{ company.registered_capital || "-" }}万</div>
                    </div>

                    <!-- 更多信息 -->
                    <template v-if="more">
                        <div class="info-item">
                            <div class="info-item_label">注册地址</div>
                            <div class="info-item_data">{{ company.registered_address || "-" }}</div>
                        </div>

                        <div class="info-item">
                            <div class="info-item_label">营业期限</div>
                            <div class="info-item_data">
                                {{ company.business_start_time || "-" }} 至 {{ company.business_end_time || "-" }}
                            </div>
                        </div>

                        <div class="info-item">
                            <div class="info-item_label">所属地区</div>
                            <div class="info-item_data">{{ company.region || "-" }}</div>
                        </div>

                        <div class="info-item">
                            <div class="info-item_label">统一社会信用代码</div>
                            <div class="info-item_data">{{ company.unified_social_credit_code || "-" }}</div>
                        </div>

                        <div class="info-item">
                            <div class="info-item_label">核准日期</div>
                            <div class="info-item_data">{{ company.approval_date || "-" }}</div>
                        </div>

                        <div class="info-item full-row">
                            <div class="info-item_label">曾用名</div>
                            <div class="info-item_data">{{ company.previous_name || "-" }}</div>
                        </div>

                        <div class="info-item full-row">
                            <div class="info-item_label">登记机关</div>
                            <div class="info-item_data">{{ company.registration_authority || "-" }}</div>
                        </div>

                        <div class="info-item full-row">
                            <div class="info-item_label">所属行业</div>
                            <div class="info-item_data">{{ company.industry || "-" }}</div>
                        </div>

                        <div class="info-item full-row">
                            <div class="info-item_label">经营范围</div>
                            <div class="info-item_data">{{ company.business_scope || "-" }}</div>
                        </div>
                    </template>
                </div>

                <div class="more flex-center">
                    <div class="more-btn flex-center" @click="more = !more">
                        <span>{{ more ? "收起" : "查看更多信息" }}</span>
                        <i :class="['iconfont', { more: more }]">&#xe771;</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="detial_item">
            <div class="title">公司地址</div>

            <div class="address_box" v-if="company.detail_address && company.detail_address.length > 0">
                <div
                    :class="['address-item', { active: index === address.active }]"
                    v-for="(item, index) in company.detail_address"
                    :key="index"
                    @click="
                        () => {
                            address.active = index;
                            address.location = item.location;
                        }
                    "
                >
                    <div class="collapse-title flex-center">
                        <i class="el-icon-location"></i>
                        {{ item.province }}{{ item.city }}{{ item.district }}{{ item.address }}
                    </div>

                    <div class="address-map" @click="address.mapVisible = true" v-if="address.active === index">
                        <MapBox :location="address.location"></MapBox>

                        <div class="view-more flex-center">
                            <img src="@/assets/map-icon.png" alt="" />
                            <span>点击查看地图</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text_box" style="color: #99999a" v-else>无</div>
        </div>

        <MapOverview v-model="address.mapVisible" :location="address.location"></MapOverview>
    </div>
</template>

<script>
import MapBox from "@/components/recruitmentCenter/job/MapBox.vue";
import MapOverview from "@/components/recruitmentCenter/job/MapOverview.vue";

export default {
    name: "",
    data() {
        return {
            address: {
                active: 0,
                mapVisible: false,
                location: "",
            },
            more: false,
        };
    },

    props: {
        company: {
            type: Object,
        },
    },

    components: {
        MapBox,
        MapOverview,
    },

    created() {
        this.address.location = this.company.detail_address?.[0]?.location || "";
    },

    methods: {},
};
</script>
<style lang="scss" scoped>
.detial_box {
    width: 100%;
    margin-top: 20px;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    padding: 25px 41px;
    box-sizing: border-box;
    .detial_item {
        margin-bottom: 20px;
        .title {
            font-weight: 500;
            font-size: 24px;
            color: #222222;
            margin-bottom: 22px;
        }
        .text_box {
            font-weight: 400;
            font-size: 20px;
            color: #333333;
            line-height: 36px;
        }
        .img_box {
            img {
                width: 268px;
                height: 160px;
            }
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
        }
        .label_box {
            .label_item {
                padding: 6px 16px;
                font-weight: 400;
                font-size: 18px;
                color: #666666;
                background: #f8f8f8;
                border-radius: 4px 4px 4px 4px;
                margin-right: 12px;
                display: inline-block;
                margin-bottom: 12px;
            }
        }
        .product_box {
            display: flex;
            img {
                width: 70px;
                height: 70px;
            }
            .product_info {
                margin-left: 10px;
                .name {
                    font-weight: 400;
                    font-size: 16px;
                    color: #424d5c;
                    margin-bottom: 10px;
                }
                .tip {
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                }
            }
        }

        .business_box {
            background: #f8f8f9;
            border-radius: 12px;
            padding: 20px 20px 16px;

            .grid-info {
                margin-bottom: 20px;
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                row-gap: 20px;

                .info-item {
                    min-width: 0;

                    &_label {
                        font-weight: 500;
                        font-size: 18px;
                        color: #99999a;
                        margin-bottom: 11px;
                    }

                    &_data {
                        font-weight: 500;
                        font-size: 20px;
                        color: #414a61;
                    }

                    &.full-row {
                        grid-column: 1 / -1;
                    }
                }
            }

            .more {
                .more-btn {
                    font-weight: 500;
                    font-size: 14px;
                    color: #00a6a8;
                    gap: 3px;
                    cursor: pointer;

                    .iconfont {
                        font-size: 12px;

                        &.more {
                            transform: rotate(180deg);
                        }
                    }
                }
            }
        }

        .address_box {
            background: #ffffff;
            border-radius: 12px;
            border: 1px solid #ededed;
            overflow: hidden;

            .address-item {
                .collapse-title {
                    padding-inline: 30px;
                    gap: 4px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #333333;
                    justify-content: flex-start;
                    padding-block: 16px;
                    cursor: pointer;
                }

                & + .address-item {
                    border-top: 1px solid #ededed;
                }

                &.active {
                    .collapse-title {
                        font-size: 20px;

                        i {
                            color: #00a6a8;
                        }
                    }
                }
            }

            .address-map {
                margin-top: 8px;
                height: 150px;
                border-radius: 8px;
                overflow: hidden;
                position: relative;

                .view-more {
                    position: absolute;
                    right: 12px;
                    bottom: 12px;
                    background-color: #ffffff;
                    border-radius: 8px;
                    gap: 4px;
                    padding: 4px 12px;
                    cursor: pointer;

                    img {
                        width: 24px;
                        height: 24px;
                        object-fit: cover;
                    }

                    span {
                        font-size: 12px;
                    }

                    &:hover {
                        span {
                            color: #685ef5;
                        }
                    }
                }
            }
        }

        .expand_button {
            width: 100%;
            display: flex;
            height: 50px;
            align-items: center;
            justify-content: end;
            font-weight: 400;
            font-size: 20px;
            color: #685ef5;
            i {
                margin-left: 5px;
            }
        }
    }
}
</style>
